import { render, staticRenderFns } from "./ReviewsSettings.vue?vue&type=template&id=b28fb99e&scoped=true&"
import script from "./ReviewsSettings.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSettings.vue?vue&type=style&index=0&id=b28fb99e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28fb99e",
  null
  
)

export default component.exports